var _path, _path2, _path3, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 630,
    height: 360,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#da0000",
    d: "M0 0h630v360H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h630v240H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#239f40",
    d: "M0 0h630v120H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.4 100.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M0 1h26M1 10V5h8v4h8V5h-5M4 9h2m20 0h-5V5h8m0-5v9h8V0m-4 0v9",
    transform: "scale(1.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 7h9m1 0h9",
    transform: "scale(2.8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    y: 120
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    y: 145.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 112
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 168
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 168
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 392
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#da0000",
    transform: "matrix(45 0 0 45 315 180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.548.836A.912.912 0 0 0 .329-.722 1 1 0 0 1-.548.836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.618.661A.764.764 0 0 0 .422-.74 1 1 0 0 1 .618.661M0 1l-.05-1L0-.787a.31.31 0 0 0 .118.099V-.1l-.04.993zM-.02-.85 0-.831a.144.144 0 0 0 .252-.137A.136.136 0 0 1 0-.925"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    transform: "scale(-1 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIr);
export default __webpack_public_path__ + "static/media/ir.4483804398c2b809f96641287570bc54.svg";
export { ForwardRef as ReactComponent };